exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#remote-screen>div{background-color:transparent!important}#remote-screen video.agora_video_player{height:auto!important}", ""]);

// exports
